import React from "react";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";
import Typography from "../typography";
import { IMatch } from "../../types";
import { Chip } from "@material-ui/core";
import moment from "moment";
import SoccerBallIcon from "@material-ui/icons/SportsSoccer";
import PersonPin from "@material-ui/icons/PersonPin";
import { injectIntl } from "react-intl";
import messages from "./PageDashboard.intl";
import { DisplayMapFC } from "./Maps";
import {
  TicketCard,
  TicketSection,
  TicketSeam,
  TimeWrapper,
  TimeBox,
  TimeValue,
  TimeSeparator,
} from "../molecules/cards";

/*
 * "Próximo partido" como una entrada de ticket, no una card más: equipos y
 * fecha arriba, costura punteada, hora + ubicación abajo. Sin foto de fondo
 * ni gradientes — ver DESIGN_SYSTEM.md.
 */

const MatchTeams = styled("div")(({ theme }: IStyledArguments) => ({
  fontFamily: theme.typography.alternateFontFamily,
  fontWeight: 700,
  fontSize: "1.05rem",
  color: theme.palette.text.primary,
  "& .vs": {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    margin: theme.spacing(0, 0.75),
    textTransform: "lowercase",
  },
}));

const MatchDate = styled("div")(({ theme }: IStyledArguments) => ({
  fontSize: "0.8rem",
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(0.5),
}));

const LocationRow = styled("div")(({ theme }: IStyledArguments) => ({
  marginTop: theme.spacing(2),
}));

const ChipsRow = styled("div")(({ theme }: IStyledArguments) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

interface IMatchSummaryCardProps {
  match: IMatch;
}

const NextMatchCard = injectIntl<IMatchSummaryCardProps>(({ match, intl }) => {
  const homeTeamName = match.isHomeTeamLocal ? match.homeTeam.name : match.awayTeam;
  const awayTeamName = match.isHomeTeamLocal ? match.awayTeam : match.homeTeam.name;
  const meetingTime = moment("2019-11-21T" + match.time + ":00Z")
    .subtract(30, "minutes")
    .format("HH:mm");

  return (
    <TicketCard>
      <TicketSection>
        <MatchTeams>
          {homeTeamName}
          <span className="vs">vs</span>
          {awayTeamName}
        </MatchTeams>
        <MatchDate>
          {moment(match.date).isSame(Date.now(), "day")
            ? intl.formatMessage(messages.today)
            : moment(match.date).format("DD-MM-YYYY")}
        </MatchDate>
      </TicketSection>

      <TicketSeam />

      <TicketSection>
        <TimeWrapper>
          <TimeBox>
            <TimeValue>{match.time.split(":")[0]}</TimeValue>
          </TimeBox>
          <TimeSeparator>:</TimeSeparator>
          <TimeBox>
            <TimeValue>{match.time.split(":")[1]}</TimeValue>
          </TimeBox>
        </TimeWrapper>

        <LocationRow>
          <Typography.Subtitle1>
            {`${intl.formatMessage(messages.location)}: ${match.location}`}
          </Typography.Subtitle1>
          <DisplayMapFC address={match.location} />
        </LocationRow>

        <ChipsRow>
          <Chip
            icon={<SoccerBallIcon />}
            size="small"
            color="primary"
            label={`${intl.formatMessage(messages.kickOff)}: ${match.time}`}
            onClick={() => null}
          />
          <Chip
            icon={<PersonPin />}
            size="small"
            variant="outlined"
            label={`${intl.formatMessage(messages.meetingTime)}: ${meetingTime}`}
            onClick={() => null}
          />
        </ChipsRow>
      </TicketSection>
    </TicketCard>
  );
});

export default NextMatchCard;
